import { c as _c } from "react/compiler-runtime";
import { removeBaseEndpoint } from "@/helpers/Helpers";
import Link from "next/link";
import { ApiDropType } from "@/generated/models/ApiDropType";
import { useDrop } from "@/hooks/useDrop";
import DropListItemContentMedia from "@/components/drops/view/item/content/media/DropListItemContentMedia";
import { SingleWaveDropPosition } from "../drop/SingleWaveDropPosition";
import { SingleWaveDropVotes } from "../drop/SingleWaveDropVotes";
import ChatItemHrefButtons from "../ChatItemHrefButtons";
export default function DropItemChat(t0) {
  const $ = _c(36);
  const {
    href,
    dropId
  } = t0;
  let t1;
  if ($[0] !== dropId) {
    t1 = {
      dropId
    };
    $[0] = dropId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    drop
  } = useDrop(t1);
  let t2;
  if ($[2] !== href) {
    t2 = removeBaseEndpoint(href);
    $[2] = href;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const relativeLink = t2;
  let t3;
  if ($[4] !== drop?.parts) {
    t3 = drop?.parts?.at(0)?.media?.at(0);
    $[4] = drop?.parts;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const artworkMedia = t3;
  let t4;
  if ($[6] !== drop?.metadata || $[7] !== drop?.title) {
    t4 = drop?.metadata?.find(_temp)?.data_value || drop?.title;
    $[6] = drop?.metadata;
    $[7] = drop?.title;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const title = t4;
  if (!drop) {
    let t5;
    if ($[9] !== href || $[10] !== relativeLink) {
      t5 = <Link href={relativeLink}>{href}</Link>;
      $[9] = href;
      $[10] = relativeLink;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    return t5;
  }
  let t5;
  if ($[12] !== relativeLink || $[13] !== title) {
    t5 = <h3 className="tw-text-base sm:tw-text-lg tw-font-semibold tw-text-iron-100 tw-mb-0"><Link className="tw-no-underline" href={relativeLink}>{title}</Link></h3>;
    $[12] = relativeLink;
    $[13] = title;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== drop) {
    t6 = drop?.drop_type === ApiDropType.Participatory && <SingleWaveDropPosition rank={drop.rank} />;
    $[15] = drop;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = <div className="tw-flex tw-flex-row tw-items-center tw-gap-x-3">{t5}{t6}</div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== drop || $[21] !== relativeLink) {
    t8 = drop && <><span className="tw-mb-0 tw-text-[11px] tw-leading-0 -tw-mt-1 tw-text-iron-500 tw-transition tw-duration-300 tw-ease-out tw-no-underline"><Link className="tw-no-underline" href={relativeLink}>{drop.wave.name}</Link></span><SingleWaveDropVotes drop={drop} /></>;
    $[20] = drop;
    $[21] = relativeLink;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== artworkMedia || $[24] !== drop) {
    t9 = artworkMedia && <div className="tw-mt-4 tw-flex tw-justify-center tw-h-96"><DropListItemContentMedia media_mime_type={artworkMedia.mime_type} media_url={artworkMedia.url} isCompetitionDrop={drop.drop_type === ApiDropType.Participatory || drop.drop_type === ApiDropType.Winner} /></div>;
    $[23] = artworkMedia;
    $[24] = drop;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t7 || $[27] !== t8 || $[28] !== t9) {
    t10 = <div className="tw-flex-1 tw-min-w-0"><div className="tw-rounded-xl tw-border tw-border-solid tw-border-iron-700 tw-p-4">{t7}{t8}{t9}</div></div>;
    $[26] = t7;
    $[27] = t8;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== href || $[31] !== relativeLink) {
    t11 = <ChatItemHrefButtons href={href} relativeHref={relativeLink} />;
    $[30] = href;
    $[31] = relativeLink;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t10 || $[34] !== t11) {
    t12 = <div className="tw-flex tw-items-stretch tw-w-full tw-gap-x-1">{t10}{t11}</div>;
    $[33] = t10;
    $[34] = t11;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  return t12;
}
function _temp(m) {
  return m.data_key === "title";
}